import { Injectable } from '@angular/core';
import { UserRole, PermissionPolicy } from '../model';
import { ResourcePermission } from './resource-permissions.config';
import { AuthenticationService } from '../services/authentication.service';
import { GetPermissionsByRole } from '../security.helper';

@Injectable()
export class AccessControlService {

    constructor(private authService: AuthenticationService) { }

    HasUserAccess(rp: ResourcePermission): boolean {
        const currentUser = this.authService.getCurrentUser();
        if (!currentUser || !currentUser.roles || currentUser.roles.length === 0) {
            return false;
        }

        if (!rp || !rp.rights || rp.rights.length === 0) {
            return false;
        }

        const roles = currentUser.roles;
        const policy = (rp.policy) ? rp.policy : PermissionPolicy.Any;

        for (const role of roles) {
            const hasPermission = this.CheckPermission(role.roleName, rp.rights, policy);
            if (hasPermission) {
                return true;
            }
        }

        return false;
    }

    private CheckPermission(roleName: string, resourceRights: string[], policy: PermissionPolicy): boolean {
        const rolePermissions = GetPermissionsByRole(roleName);
        if (!rolePermissions) {
            return false;
        }

        let hasRight = false;
        for (const right of resourceRights) {
            const hasRolePermission = rolePermissions[right];

            if (hasRolePermission && policy === PermissionPolicy.Any) {
                return true;
            }

            if (!hasRolePermission && policy === PermissionPolicy.All) {
                return false;
            }

            if (hasRolePermission) {
                hasRight = true;
            }

        }

        return hasRight;
    }
}



// WEBPACK FOOTER //
// /home/runner/work/cdg-missioncontrol/cdg-missioncontrol/MissionControlClient2/MissionControl.WebUi2/mc-app/src/app/core/security/access-control/access-control.service.ts